/**
 * Agent Preference Service (Frontend)
 * API client for per-user agent preferences.
 */

import apiClient from './apiClient';

class AgentPreferenceService {
  async getHiddenAgentIds() {
    return apiClient.get('/api/agent-preferences/hidden');
  }

  async setAgentHidden(rolId, hidden) {
    return apiClient.put(`/api/agent-preferences/${rolId}/hidden`, { hidden });
  }
}

export default new AgentPreferenceService();
